import { render, staticRenderFns } from "./LeaveTypeSettingsTable.vue?vue&type=template&id=5215bf4a&"
import script from "./LeaveTypeSettingsTable.vue?vue&type=script&lang=js&"
export * from "./LeaveTypeSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports